module.exports = __webpack_public_path__ + "media/bell.902e6a0b.wav";